module.exports = __webpack_public_path__ + "static/media/Tram.a899f771.webp";